import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=24263477&scoped=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&lang=js"
import style0 from "./DownloadIcon.vue?vue&type=style&index=0&id=24263477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24263477",
  null
  
)

export default component.exports